import React, { useState, useContext, useEffect } from "react";
import { Box, Button, Anchor, Text, Layer } from "grommet";
import { History } from "grommet-icons";

import UserContext from "../../context/UserContext";

import { gql, useQuery } from '@apollo/client';

import AgDataTable from '../common/AgDataTable'
import * as moment from "moment-timezone";
import Spinner from "../common/Spinner";


const BLACKLISTED_APPS = [
    "beats",
    "build-essential",
    "chef_handler",
    "chef-splunk",
    "chef-vault",
    "cloudhealth",
    "colocachingproxy",
    "compat_resource",
    "cpu",
    "cron",
    "cron_tz",
    "deploy_user",
    "diagnostics",
    "extract",
    "feature_flags",
    "firewalld",
    "get_python",
    "graphite",
    "instance_identifier",
    "iptables",
    "jdk",
    "jvmtop",
    "ldap",
    "locals3",
    "logrotate",
    "luna",
    "mcast_proxy",
    "monitoring_utils",
    "nameserver",
    "nginx",
    "nginx_wrapper",
    "ntp",
    "ohai",
    "performance",
    "poise",
    "poise-service",
    "projhgopenvpn",
    "purge_chef_backup",
    "resizefs",
    "resolv",
    "s3",
    "s3_file",
    "selinux",
    "sfptp",
    "splunk2",
    "stealthwatch",
    "syslog",
    "systemd",
    "traffic_shape",
    "ulimit",
    "upstart",
    "virtualip",
    "yum",
    "yum-epel",
    "zypper",
]


const VersionHistory = ({
    host, serviceName = ""
}) => {

    const [showVersionHistory, setshowVersionHistory] = useState(false);

    return (
        <>
            <Box
                justify="center"
                align="center"
                gap="none"
                background="dark-2"
                alignSelf="center"
                alignContent="center"
                round="xsmall"
            >
                <Anchor
                    alignSelf="center"
                    margin={{ left: "6px", right: "6px" }}
                    onClick={() => {
                        setshowVersionHistory(true);
                    }}
                >
                    <Button
                        plain
                        color="white"
                        label={
                            <Text size="12px" weight="normal">
                                Version History
                            </Text>
                        }
                        margin={{ top: "xxsmall" }}
                        hoverIndicator={{ color: "light-1", opacity: "weak" }}
                        icon={<History size="16px" color="white" />}
                    />
                </Anchor>
            </Box>

            {showVersionHistory && (
                <VersionHistoryBrowser
                    host={host}
                    setshowVersionHistory={setshowVersionHistory}
                    serviceName={serviceName}
                />
            )}
        </>
    );
};

const VersionHistoryBrowser = ({
    host, setshowVersionHistory, serviceName = ""
}) => {

    const VERSION_HISTORY = gql`
    query($node: String!, $blacklistApps: [String!]!) {
        applicationVersions(
            where: { node: { _eq: $node }, app: { _nin: $blacklistApps } }
        ) {
            app
            installed_epoch
            version
            id
        }
    }    
  `;

  const VERSION_CURRENT = gql`
  query ($nodes: [String!]!) {
    serviceGroup_node(where: { node: { name: { _in: $nodes } } }) {
        cb_versions: chef(path: "cookbook_deployment_data")
    }
  }
  `;

    const historyVersions = useQuery(VERSION_HISTORY, {
        variables: { node: host, blacklistApps: BLACKLISTED_APPS },
    });

    const currentVersions = useQuery(VERSION_CURRENT, {
        variables: { nodes: [host] },
    });

    const token = useContext(UserContext);

    const tab_col = [
        {
            field: "app",
            headerName: "Application",
            minWidth: 150,
            cellStyle: function (params) {
                if (params.data.app === serviceName) {
                    return { color: 'black', backgroundColor: '#FDFB98' };
                }
            },
        },
        {
            field: "installed",
            headerName: "Installed",
            sort: "desc",
            minWidth: 150,
        },
        {
            field: "version",
            headerName: "Version",
            minWidth: 150,
        },
    ];

    const [tab_data, setTabData] = useState([])
    const [historyData, setHistoryData] = useState([])
    const [currentData, setCurrentData] = useState([])

    const [hideall, sethideall] = useState(true)

    const handleClick = () => {
        sethideall(!hideall)
    }

    useEffect(() => {
        let tab_data_temp = []
        if (!historyVersions.loading && historyVersions.data) {
            historyVersions.data.applicationVersions &&
                historyVersions.data.applicationVersions.forEach(app => {
                    if (hideall && serviceName) {
                        if (app.app === serviceName) {
                            let installedTime = app.installed_epoch
                            installedTime = moment.unix(installedTime).format("YYYY-MM-DD HH:mm:ss ZZ")
                            installedTime = moment(installedTime).tz(token.timezone).format("YYYY-MM-DD HH:mm:ss ZZ");

                            tab_data_temp.push({
                                'uniqueId': app.app + app.version,
                                'app': app.app,
                                'installed': installedTime,
                                'version': app.version,
                            })
                        }
                    } else {
                        let installedTime = app.installed_epoch
                        installedTime = moment.unix(installedTime).format("YYYY-MM-DD HH:mm:ss ZZ")
                        installedTime = moment(installedTime).tz(token.timezone).format("YYYY-MM-DD HH:mm:ss ZZ");

                        tab_data_temp.push({
                            'uniqueId': app.app + app.version,
                            'app': app.app,
                            'installed': installedTime,
                            'version': app.version,
                        })
                    }
                });
            setHistoryData(tab_data_temp)
        }
    }, [historyVersions.loading, historyVersions.data, token.timezone, hideall, serviceName])

    useEffect(() => {
        let tab_data_temp = []
        if (!currentVersions.loading && currentVersions.data) {
            currentVersions.data.serviceGroup_node.forEach(row => {
                Object.keys(row.cb_versions).forEach(app => {
                    if (hideall && serviceName) {
                        if (app === serviceName) {
                            let appVersion = row.cb_versions[app].version
                            let installedTime = row.cb_versions[app].installed_epoch
                            installedTime = moment.unix(installedTime).format("YYYY-MM-DD HH:mm:ss ZZ")
                            installedTime = moment(installedTime).tz(token.timezone).format("YYYY-MM-DD HH:mm:ss ZZ");

                            tab_data_temp.push({
                                'uniqueId': app + appVersion,
                                'app': app,
                                'installed': installedTime,
                                'version': appVersion + "(Current)",
                            })
                        }
                    } else {
                        let appVersion = row.cb_versions[app].version
                        let installedTime = row.cb_versions[app].installed_epoch
                        installedTime = moment.unix(installedTime).format("YYYY-MM-DD HH:mm:ss ZZ")
                        installedTime = moment(installedTime).tz(token.timezone).format("YYYY-MM-DD HH:mm:ss ZZ");

                        tab_data_temp.push({
                            'uniqueId': app + appVersion,
                            'app': app,
                            'installed': installedTime,
                            'version': appVersion + "(Current)",
                        })
                    }
                })
            setCurrentData(tab_data_temp)})
        }
    }, [currentVersions.loading, currentVersions.data, token.timezone, hideall, serviceName])

    useEffect(() => {
        setTabData([...historyData, ...currentData])
    }, [currentData, historyData])

    return (
        <Layer
            full="horizontal"
            position="right"
            margin={{top: "50px", left: (window.innerWidth*0.65) + "px", bottom: "50px", right: "30px"}}
            onEsc={() => {
                setshowVersionHistory(false);
            }}
            onClickOutside={() => {
                setshowVersionHistory(false);
            }}
        >
            <Box pad="small" background="light-1">
                <Box direction="column" height="230px">
                    <Text size="medium" color="brand" weight="bold">Application Versions ({host})</Text>
                    <Box pad="small" width="300px" direction="row" gap="small">
                        <Button primary onClick={() => handleClick()} label={<Text size="15px">{!hideall ? "Filter by: " + serviceName : "Show All Apps"}</Text>} />
                    </Box>
                </Box>
                {(!historyVersions.loading && !currentVersions.loading) ?
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName="ApplicationVersionsv2"
                    />
                    :
                    <Spinner />
                }
            </Box>
        </Layer>
    )
}

export default VersionHistory
